import Vue from 'vue'
import Router from 'vue-router'
import Optout from '@/components/Optout'
import Success from '@/components/Success'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Optout',
      component: Optout
    },
    {
      path: '/success',
      name: 'Success',
      component: Success
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js